import React from 'react'
import styled from 'styled-components'

const FloatingLinks = () => {
    return (
        <Container>
            <SingleLink href={'https://www.giphy.com/privacy'}>Privacy</SingleLink>
            <SingleLink href={'https://www.giphy.com/terms'}>Terms</SingleLink>
        </Container>
    )
}
export default FloatingLinks

const Container = styled.div`
    display: flex;
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 2147483639;
`

const SingleLink = styled.a`
    border: none !important;
    color: #aeaeae;
    font-family: interface, 'Helvetica Neue', helvetica, sans-serif;
    font-size: 16px;
    margin-right: 10px;
    border-radius: 5px;
    background: #212121;
    padding: 6px;
    &:hover {
        text-decoration: none;
        color: white;
    }
`
